import { createContext } from "react";
import { AffiliateDetails, UpdateAffiliateDetails } from "../../types/affiliate";

export interface AffiliateContextType {
  details: AffiliateDetails | null;
  isLoading: boolean;
  error: string | null;
  refetchAffiliate: () => Promise<void>;
  updateDetails: (data: UpdateAffiliateDetails) => Promise<void>;
}

export const AffiliateContext = createContext<AffiliateContextType | null>(null);